import { getPath } from '@/router/common'

const baseUrl = {
  title: '操作员',
  path: 'czy'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'CzyIndex',
    component: () => import('@/views/czy/index/index.vue'),
    meta: {
      title: '操作员'
    }
  },
  {
    path: getPath('ModifyUser', baseUrl),
    name: 'ModifyUser',
    component: () =>
      import(
        /* webpackChunkName: "ModifyUser" */ '@/views/czy/ModifyUser/index.vue'
      ),
    meta: {
      title: '操作员档案新增'
    }
  }
]
